import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const items = [
  { label: '販売業者', value: 'Dr.Catch' },
  { label: '運営責任者', value: 'ジェイゾロフト瞳' },
  { label: 'メールアドレス', value: 'info@drcatch.jp' },
  { label: 'サービス提供形態', value: 'オンラインカウンセリング（ビデオ通話・チャット）' },
  {
    label: '販売価格',
    value: '各セッションの料金は予約ページに記載の金額とします。表示価格はすべて税込みです。',
  },
  {
    label: '支払方法',
    value: 'クレジットカード（VISA・Mastercard・JCB・American Express）\n銀行振込',
  },
  {
    label: '支払時期',
    value: 'セッション予約確定時にお支払いいただきます。',
  },
  {
    label: 'サービス提供時期',
    value: '予約確定後、指定の日時にセッションを実施します。',
  },
  {
    label: 'キャンセル・返品について',
    value:
      'セッション開始の24時間前までのキャンセルは全額返金いたします。\n24時間以内のキャンセルおよび無断キャンセルは返金対象外となります。\nサービスの性質上、セッション実施後の返金はお受けできません。',
  },
  {
    label: '動作環境',
    value:
      'ビデオ通話セッションのご利用には、カメラ・マイク付きのデバイスおよびインターネット接続環境が必要です。推奨ブラウザ：Google Chrome最新版、Safari最新版',
  },
  {
    label: '個人情報の取り扱い',
    value: 'プライバシーポリシーをご確認ください。',
  },
];

export default function Legal() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] to-white">
      <Navigation />

      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-14">
            <p className="text-sm tracking-[0.3em] text-[#C9A0A0] uppercase mb-3">Specified Commercial Transactions Act</p>
            <h1 className="text-3xl md:text-4xl font-serif mb-4 text-[#2C2C2C]">特定商取引法に基づく表記</h1>
            <div className="w-24 h-px bg-[#D4A5A5] mx-auto mb-4"></div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#F5E8E4] overflow-hidden mb-10">
            {items.map((item, index) => (
              <div
                key={item.label}
                className={`flex flex-col md:flex-row ${index !== items.length - 1 ? 'border-b border-[#F5E8E4]' : ''}`}
              >
                <div className="md:w-48 flex-shrink-0 bg-[#FFF0EC] px-6 py-5">
                  <p className="text-sm font-semibold text-[#2C2C2C] whitespace-nowrap">{item.label}</p>
                </div>
                <div className="flex-1 px-6 py-5">
                  <p className="text-sm leading-loose text-[#4A4A4A] whitespace-pre-line">{item.value}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#F5E8E4] mb-10">
            <h2 className="text-base font-semibold text-[#2C2C2C] mb-3 flex items-center gap-3">
              <span className="w-1.5 h-5 bg-[#D4A5A5] rounded-full inline-block flex-shrink-0"></span>
              ご注意
            </h2>
            <p className="text-sm leading-loose text-[#4A4A4A]">
              本サービスは医療行為を提供するものではありません。精神科・心療内科等の医療機関への受診が必要と判断される場合は、適切な医療機関をご案内いたします。ご不明な点はメールにてお問い合わせください。
            </p>
          </div>

          {/* Back link */}
          <div className="text-center mt-14">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#C9A0A0] hover:text-[#B88B8B] transition-colors text-sm cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              トップページに戻る
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
